import { AiFillEdit, AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AiFillDelete } from "react-icons/ai";
import { server } from "../../../common";
import useQuickLook from "../../../quicklook/useQuickLook";
import { useSelectAccess } from "../../../store/stateFunctions";

const swalalert = withReactContent(Swal);

const NewsFromIndustry = () => {
  const user = useSelectAccess("Super Admin");
  const [data, setData] = useState([]);
  const displayFile = useQuickLook();
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);

  // Edit form data
  const [editFormData, setEditFormData] = useState({
    title: "",
    description: "",
    category: "",
    image: null,
  });

  useEffect(() => {
    getData();
  }, []);

  // Get
  const getData = () => {
    server
      .get("/news/getallind_news", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete
  const handleDelete = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/news/deleteind_news/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "News has been deleted.", "success");
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // Open modal for confirmation
  const handleOpenModal = (blog, status) => {
    setSelected(blog);
    setSelectedStatus(status);
    setShowModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelected(null);
    setSelectedStatus("");
  };

  // Update Status
  const updateStatus = async () => {
    try {
      await server.put(
        `/news/update_approval_status/${selected.id}`,
        { status: selectedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        }
      );
      toast.success("News Status Updated successfully");
      getData();
      handleCloseModal();
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data?.message)
        toast.error(error.response.data.message);
      else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to connect to the server");
        console.log(error.message);
      }
    }
  };

  // Edit internship
  const handleEdit = (selected) => {
    console.log("Selected object:", selected);
    setEditFormData({
      title: selected.title,
      description: selected.description,
      category: selected.category,
      image: null,
    });
    setShowEditModal(true);
    setSelected(selected); // Fix: Set selected, not data
  };

  // Close edit modal
  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditFormData({
      title: "",
      description: "",
      category: "",
      image: null,
    });
  };

  // Update internship details
  const handleUpdateInternship = async (e) => {
    e.preventDefault();

    // Check if selected is null or undefined
    if (!selected || !selected.id) {
      console.error("Invalid selected object or missing ID.");
      return;
    }

    try {
      const formData = new FormData();
      if (!editFormData.image) {
        toast.error("Please select a images");
        return;
      }
      formData.append("title", editFormData.title);
      formData.append("description", editFormData.description);
      formData.append("category", editFormData.category);
      formData.append("image", editFormData.image);

      server
        .put(`/news/updateadmindnews/${selected.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          // formik.resetForm();
          getData();
          toast.success("Internship Updated successfully");
          handleCloseEditModal();
        })
        .catch(function (error) {
          if (error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else toast.error("Failed to connect to server");
        });

      // Close the edit modal
      handleCloseEditModal();
      getData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="container">
        <h2 className="text-center py-4">Industry News</h2>
        <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              name=""
              className="form-control"
              placeholder="Search"
              id=""
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select className="form-control" name="" id="">
              <option value="">Latest</option>
              <option value="">Last Month</option>
              <option value="">Last Year</option>
            </select>
          </div>
        </div>
        <table className="table table-striped border text-center">
          <thead>
            <tr>
              <th scope="col">Sr. No.</th>
              <th scope="col">Title</th>
              <th scope="col">Description</th>
              <th scope="col">Category</th>
              <th scope="col">News Images</th>
              <th scope="col">Status</th>
              <th>Update Status</th>
              <th scope="col">Edit/Delete</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              const statusOptions = {
                Sent: ["Reviewed"],
                Reviewed: ["Approved"],
                Approved: ["Post"],
                Post: ["Rejected"],
                Rejected: ["Approved"],
              }[item.status];
              return (
                <tr key={item.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{item.title}</td>
                  <td>{item.description}</td>
                  <td>{item.category}</td>
                  <td>
                    <a href={item.image} target="_blank">
                      <img width="50" height="50" src={item.image} />
                    </a>
                  </td>
                  <td>{item.status}</td>
                  <td>
                    {statusOptions &&
                      statusOptions.map((option) => (
                        <button
                          key={option}
                          className="p-1 border-0 rounded-2 banner text-white"
                          onClick={() => handleOpenModal(item, option)}
                        >
                          {option}
                        </button>
                      ))}
                  </td>

                  <td>
                    <div>
                      <AiFillEdit
                        onClick={() => handleEdit(item)}
                        className="fs-4"
                      />
                      <br />
                      <br />
                      <AiFillDelete
                        onClick={() => handleDelete(item)}
                        className="fs-4"
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal for confirmation */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Status Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update the status to {selectedStatus}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            className="ms-2"
            onClick={updateStatus}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for edit */}
      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Internship Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Form to edit internship details */}
          <form onSubmit={handleUpdateInternship}>
            <div className="form-outline mb-2">
              <TextField
                name="title"
                margin="dense"
                type="text"
                placeholder="Company Name"
                variant="outlined"
                label="Company Name"
                value={editFormData.title}
                onChange={(e) =>
                  setEditFormData({
                    ...editFormData,
                    title: e.target.value,
                  })
                }
                fullWidth
                required
              ></TextField>
            </div>

            <div className="form-outline mb-2">
              <TextField
                name="description"
                margin="dense"
                type="text"
                placeholder="Description"
                variant="outlined"
                label=" Description"
                value={editFormData.description}
                onChange={(e) =>
                  setEditFormData({
                    ...editFormData,
                    description: e.target.value,
                  })
                }
                fullWidth
                required
              ></TextField>
            </div>
            <div className="mb-2">
              <FormControl fullWidth required className="mt-2">
                <InputLabel id="demo-simple-select-label">Category</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Year"
                  variant="outlined"
                  name="category"
                  value={editFormData.category}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      category: e.target.value,
                    })
                  }
                  required
                >
                  <MenuItem value="city">City </MenuItem>
                  <MenuItem value="industry">Industry </MenuItem>
                  <MenuItem value="institute">Institute </MenuItem>
                  <MenuItem value="university">University </MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="form-outline mb-2">
              <TextField
                name="image"
                margin="dense"
                type="file"
                variant="outlined"
                label="Company logo"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <label htmlFor="image">Upload Image</label>
                    </InputAdornment>
                  ),
                  inputProps: {
                    accept: ".jpg, .png, .jpeg",
                    onChange: (e) => {
                      const selectedFile = e.target.files[0]; // Get the selected file
                      setEditFormData({
                        ...editFormData,
                        image: selectedFile,
                      });
                    },
                  },
                }}
              />
            </div>

            <button
              className="p-1 border-0 rounded-2 banner text-white"
              type="submit"
            >
              Save Changes
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewsFromIndustry;
